import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { SecondaryPagesModal } from "../../components/SecondaryPagesModal";
import {
  useCreateSectorMutation,
  useDeleteSectorMutation,
  useLazyGetAllSectorsQuery,
  useUpdateSectorMutation,
} from "../../store/service/adbService";
import { setLoader } from "../../store/slice/dashboard";
import { DeleteModal } from "../../components/Project/DeleteModal";
import {Paginate} from "../../components/Paginate";

export const SectorPage = ({}) => {
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [deleteModal, setDeleteModal] = useState(null);
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPage, setTotalPage] = useState(0)

  const [getSectors, {
    data: sectors,
    isLoading: sectorsIsLoading,
  }] = useLazyGetAllSectorsQuery();

  const [
    createSector,
    {
      isSuccess: createSectorIsSuccess,
      isLoading: createSectorIsLoading,
    },
  ] = useCreateSectorMutation();

  const [
    deleteSector,
    {
      isLoading: deleteSectorIsLoading,
    },
  ] = useDeleteSectorMutation();

  const [
    updateSector,
    {
      isSuccess: updateSectorIsSuccess,
      isLoading: updateSectorIsLoading,
    },
  ] = useUpdateSectorMutation();

  useEffect(() => {
    getSectors({
      per_page: 10,
      page: currentPage,
    })
  }, [currentPage])

  useEffect(() => {
    if (sectors) {
      setTotalPage(sectors?.data?.last_page)
    }
  }, [sectors])

  useEffect(() => {
    !modal && setCurrentItem(null);
  }, [modal]);

  useEffect(() => {
    setModal(false);
    setCurrentItem(null);
  }, [createSectorIsSuccess, updateSectorIsSuccess]);

  useEffect(() => {
    sectorsIsLoading ||
    createSectorIsLoading ||
    updateSectorIsLoading ||
    deleteSectorIsLoading
      ? dispatch(setLoader(true))
      : dispatch(setLoader(false));
  }, [
    sectorsIsLoading,
    createSectorIsLoading,
    updateSectorIsLoading,
    deleteSectorIsLoading,
  ]);

  return (
    <div className="s-pages">
      {deleteModal?.show && (
        <DeleteModal
          id={deleteModal?.id}
          action={deleteSector}
          setDeleteModal={setDeleteModal}
        />
      )}
      {modal && (
        <SecondaryPagesModal
          title="Sector"
          setModal={setModal}
          label="Sector Name"
          createHook={createSector}
          updateHook={updateSector}
          currentItem={currentItem}
        />
      )}
      <div className="s-page__header">
        <h1>Sector</h1>
        <button onClick={() => setModal(true)}>
          <img src="/assets/icons/plus.svg" alt="plus" />
          <span>Create Sector</span>
        </button>
      </div>

      <div className="table">
        <div className="table-header">
          <div className="table-th">Sector Name</div>
        </div>
        {
          sectors?.data?.data?.length > 0 ?
              <div className="table-body">
                {sectors?.data?.data?.map((item) => (
                    <div className="table-row" key={item?.id} id={item?.id}>
                      <div className="table-td">{item?.name}</div>
                      <div className="table-actions">
                        <div
                            className="table-delete"
                            onClick={() => {
                              setDeleteModal({ id: item?.id, show: true });
                              // deleteSector(item?.id)
                            }}
                        >
                          <img src="/assets/icons/trash-icon.svg" alt="trash" />
                          <span>Delete</span>
                        </div>
                        <div
                            className="table-edit"
                            onClick={() => {
                              setCurrentItem(item);
                              setModal(true);
                            }}
                        >
                          <img src="/assets/icons/edit-icon-2.svg" alt="edit" />
                          <span>Edit</span>
                        </div>
                      </div>
                    </div>
                ))}
              </div> :
              <div style={{height: '70vh', width: '100%', display: "flex", justifyContent:"center", alignItems: 'center', flexDirection: "column"}}>
                <img src="/assets/images/projects.png" alt=""/>
                <span style={{color: "#767676", fontSize: 16, fontWeight: 500}}>No Sectors</span>
              </div>
        }
      </div>
      {(sectors?.data?.data?.length > 0 && totalPage > 0) && <Paginate currentPage={currentPage} setCurrentPage={setCurrentPage} pageCount={totalPage}/>}
    </div>
  );
};
